module.exports = __webpack_public_path__ + "static/media/entry-information.db9daa97.svg";